
import { CommApiInstance } from "Utils/CommApiInstance";



const IsLoginApi = async () => {
    return await CommApiInstance.post(`athn/login/is_login`,{
        apiBody:"",
    },)
    .then((Resp) => Resp.data);
}


export default IsLoginApi;
